<template>
  <div class="container-login">
    <v-form>
      <v-container fluid style="width: 100% !important; max-width: 100% !important">
        <v-row justify="center">
          <v-col cols="4">
            <v-row>
              <v-col cols="12" class="text-center text-4xl font-semibold">
                <font class="textcolor1--text">SmartLink </font><font class="light-blue--text textcolor2--text">Platform</font>
              </v-col>
              <v-col cols="12"><div style="height: 30px;"></div></v-col>
              <v-col cols="12" class="text-center text-3xl font-semibold textcolor1--text blue--text">
                Resend the email?
              </v-col>
              <v-col cols="12" class="text-sm">
                If you need to resend verification email, click the button below:
              </v-col>
              <v-col cols="12">
                <v-btn
                  block
                  x-large
                  color="primary"
                  @click="resend()"
                >
                Resend the email<v-icon class="ml-3" small>fa fa-thumbs-up</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <dialogWindow
      ref="ResendEmailDialog"
      :info="checkDialogTitle"
      size="max"
      :color="checkDialogColor"
    >
    </dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
  export default {
    components: {
      dialogWindow,
    },
    data: () => ({
      checkDialogColor: 'success',
      checkDialogTitle: '',
    }),

    mounted() {
    },

    methods: {
      resend() {
        const path = this.$route.path;
        const arrParams = path? path.split('/') : '';
        const usrId = arrParams[2]? arrParams[2] : '';
        const param = {usrId: usrId}
        this.$store.dispatch('membership/resendEmail', param).then((res) => {
          if (res.status === 0) {
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = res.message;
          } else {
            this.checkDialogColor = 'success';
            this.checkDialogTitle = res.message;
          }
          this.$refs.ResendEmailDialog.dialog = true;
          console.log("Resend Email ok", res)
        }).catch((err) => {
          console.log("Resend Email", err)
        });
      },
    }
  }
</script>